module.exports = __webpack_public_path__ + "static/media/SourceSansPro-ExtraLight.23a4c2de.ttf";